// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"c98ff9c1","107":"4959c07d","488":"5787b562"}[chunkId] + ".chunk.js";
};